export default {
  /* Get costs */
  AWS_MAP_GET_COSTS: 'AWS_MAP_GET_COSTS',
  AWS_MAP_GET_COSTS_SUCCESS: 'AWS_MAP_GET_COSTS_SUCCESS',
  AWS_MAP_GET_COSTS_ERROR: 'AWS_MAP_GET_COSTS_ERROR',
  AWS_MAP_GET_COSTS_CLEAR: 'AWS_MAP_GET_COSTS_CLEAR',

  /* Dates */
  AWS_MAP_SET_COSTS_DATES: 'AWS_MAP_SET_COSTS_DATES',
  AWS_MAP_RESET_COSTS_DATES: 'AWS_MAP_RESET_COSTS_DATES',
  AWS_MAP_CLEAR_COSTS_DATES: 'AWS_MAP_CLEAR_COSTS_DATES',

  /* Filter */
  AWS_MAP_SET_FILTER: 'AWS_MAP_SET_FILTER',
  AWS_MAP_RESET_FILTER: 'AWS_MAP_RESET_FILTER',
};



// WEBPACK FOOTER //
// ./src/constants/aws/mapTypes.js